// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"ae552272","165":"c4a52e78","369":"aa0ee84e","820":"a9a7fd05","847":"3e26f192","917":"471057ef"}[chunkId] + ".chunk.js";
};